import { Story, PrevNextDetails } from '../../components/common/utilities/newsStoryPopupTypes';
import {
    ClearPopupDataType,
    CLEAR_STORIES_POPUP_DATA,
    SET_STORIES_POPUP_RETURN_PATH_INFO_AND_PARAMS,
    SetPopupReturnPathInfoAndParamsActionType,
    SET_POPUP_VIEW_STORIES,
    SetPopupViewStoriesActionType, 
    GET_POPUP_STORY, 
    GetPopupStoryActionType,
    SET_SOURCE_STORIES,
    SetSourceStoriesActionType } from '../actions/storyPopupAction';

interface StoryPopupState {
    currentStoryIndex?: number;
    nextStoryIndex?: number;
    prevStoryIndex?: number;
    nextStoryDetails?: PrevNextDetails;
    prevStoryDetails?: PrevNextDetails;
    isCurrentStoryWithMapsOrIndexTag: boolean;
    popupStories?: Story[],
    currentStory?: Story,
    sourceRoute?: string;
    sourceRouteName?: string;
    lastError?: any;
    isLoadingNewsStoryById?: boolean;
}
const initialState: StoryPopupState = {
    isCurrentStoryWithMapsOrIndexTag: false
};

type StoryPopupActionType = GetPopupStoryActionType | 
    SetPopupReturnPathInfoAndParamsActionType | 
    SetPopupViewStoriesActionType | 
    ClearPopupDataType | 
    SetSourceStoriesActionType ;

export function newsStoryPopup(state = initialState, action: StoryPopupActionType): StoryPopupState
{
    switch (action.type)
    {
        case GET_POPUP_STORY.pending:
        {
            return {
                ...state,
                isLoadingNewsStoryById: true,
                currentStory: undefined,
                lastError: undefined
            };
        }
        case GET_POPUP_STORY.fulfilled:
        {
            return {
                ...state,
                currentStory: action.payload?.Story,
                isLoadingNewsStoryById: false
            };
        }
        case GET_POPUP_STORY.rejected:
        {
            return {
                ...state,
                currentStory: undefined,
                isLoadingNewsStoryById: false,
                lastError: action.payload
            };
        }
        case SET_POPUP_VIEW_STORIES:
        case SET_STORIES_POPUP_RETURN_PATH_INFO_AND_PARAMS:
        {
            return {
                ...state,
                ...action.payload
            };
        }
        case SET_SOURCE_STORIES:
        {
            return {
                ...state,
                popupStories: action.payload
            };
        }
        case CLEAR_STORIES_POPUP_DATA: 
        {
            return {
                ...state,
                currentStoryIndex: undefined,               
                nextStoryIndex: undefined,
                prevStoryIndex: undefined,
                isCurrentStoryWithMapsOrIndexTag: false,
                popupStories: [],
                currentStory: undefined,
                sourceRoute: undefined,
                sourceRouteName: undefined,
                prevStoryDetails: undefined,
                nextStoryDetails: undefined,
                lastError: {}
            };
        }
    }

    return state;
}